import PropTypes from 'prop-types';
import cx from 'classnames';
import { useIntl, defineMessages } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { setUIState } from '@plone/volto/actions/form/form';

import IconCardGridBlocksEditor from './IconCardGridBlocksEditor';
import { IconCardGridSchema } from './schema';
import View from './View';
import { EditPreviewContext } from '../../../helpers/editPreviewContext';

const messages = defineMessages({
  sidebarHelp: {
    id: 'Icon card grid sidebar help',
    defaultMessage:
      'Selecciona una targeta per editar-la, o fes servir «+ Element» per afegir-ne una de nova.',
  },
});

const resolveColumns = (data) => Number(data?.columns) || 2;

const Edit = (props) => {
  const {
    data,
    block,
    onChangeBlock,
    selected,
    pathname,
    manage,
    metadata,
    properties,
  } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const gridSelected = useSelector((state) => state.form.ui.gridSelected);
  const layoutItems = data?.blocks_layout?.items || [];
  const isCardSelected = layoutItems.includes(gridSelected);
  const schema = IconCardGridSchema({ intl });
  const columns = resolveColumns(data);

  const setGridSelected = (id) => {
    dispatch(setUIState({ gridSelected: id }));
  };

  if (!selected) {
    return (
      <EditPreviewContext.Provider value>
        <View data={data} path={pathname} metadata={metadata || properties} />
      </EditPreviewContext.Provider>
    );
  }

  return (
    <>
      <div
        className={cx('icon-card-grid-edit', {
          'icon-card-grid-edit--cols-3': columns === 3,
        })}
      >
        <IconCardGridBlocksEditor
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
          pathname={pathname}
          selected={selected}
          manage={manage}
          metadata={metadata}
          properties={properties}
          gridSelected={gridSelected}
          setGridSelected={setGridSelected}
          defaultVariant={columns === 3 ? 'label-top' : 'stacked'}
        />
      </div>
      <SidebarPortal selected={selected && !isCardSelected}>
        <div className="icon-card-grid-sidebar-help">
          <BlockDataForm
            schema={schema}
            title={schema.title}
            onChangeField={(id, value) => {
              onChangeBlock(block, { ...data, [id]: value });
            }}
            formData={data}
            block={block}
            onChangeBlock={onChangeBlock}
          />
          <p>{intl.formatMessage(messages.sidebarHelp)}</p>
        </div>
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  pathname: PropTypes.string.isRequired,
  manage: PropTypes.bool.isRequired,
  metadata: PropTypes.objectOf(PropTypes.any),
  properties: PropTypes.objectOf(PropTypes.any),
};

export default withBlockExtensions(Edit);
